<template>
  <div>
    <div class="dflex mt-3">
      <div class="vform-hint mb-3">{{ $t('partLegendHint') }}</div>
      <div class="col row">
        <label class="vform-editor-label section mt-0">{{ $t('vform.titleAlignment') }}</label>
      </div>
      <div
          v-for="(align, index) in titleAlignments"
          :key="index"
          :class="['vform-alignment-button', align === element.titleAlignment ? 'active' : '']"
          @click="setTitleAlignment(align)">
        <icon :type="'align-' + align" size="1"/>
      </div>
    </div>
    <div class="dflex mt-3">
      <div class="col row">
        <label class="vform-editor-label section mt-0">{{ $t('vform.textAlignment') }}</label>
      </div>
      <div
          v-for="(align, index) in textAlignments"
          :key="index"
          :class="['vform-alignment-button', align === element.textAlignment ? 'active' : '']"
          @click="setTextAlignment(align)">
        <icon :type="'align-' + align" size="1"/>
      </div>
    </div>
    <label class="vform-editor-label section">Border Color</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)"/>
    <color-picker-and-field
        v-else
        :field-background-color="element.borderColor"
        @saveColor="(color) => {setItemColor('borderColor', color)}"
        @unsetColor="setItemColor('borderColor', null)"
    />

    <label class="vform-editor-label section">Font Color</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)"/>
    <color-picker-and-field
        v-else
        :field-background-color="element.fontColor"
        @saveColor="(color) => {setItemColor('fontColor', color)}"
        @unsetColor="setItemColor('fontColor', null)"
    />

    <label class="vform-editor-label section">Background Color</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)"/>
    <color-picker-and-field
        v-else
        :field-background-color="element.backgroundColor"
        @saveColor="(color) => {setItemColor('backgroundColor', color)}"
        @unsetColor="setItemColor('backgroundColor', null)"
    />
    <div class="col row dflex mt-4">
      <div class="dflex">
        <label :for="'chkEmphasized' + $vnode.key" class="container vform-editor-body">{{ $t("emphasized") }}
          <input
              :id="'chkEmphasized' + $vnode.key"
              v-model="element.emphasized"
              type="checkbox"
          >
          <span class="checkmark"/>
        </label>
      </div>
    </div>
    <meta-fields-selection
        :organization-id="organizationId"
        :selected-meta-fields="element.metaFields ? element.metaFields : []"
        :include-super-org-metasets="superOrgMetasets"
        @updateMetaFieldSelection="updateMetaFieldSelection"
    />
  </div>
</template>

<script>
import {vFormControls} from "@/enum";
import Icon from "../Icon";
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js";
import ColorPickerAndField from "@/components/widgets/editors/ColorPickerAndField.vue";
import MetaFieldsSelection from "@/components/vForm/MetaFieldsSelection.vue";
import SetByTemplate from "@/components/vForm/SetByTemplate.vue";
export default {
  name: "VFormPARTLEGEND",
  components: {
    ColorPickerAndField,
    Icon,
    MetaFieldsSelection,
    SetByTemplate
  },
  mixins: [vFormElementMixin],
  data() {
    return {
      vFormControls: vFormControls,
      titleAlignments: ["left", "center", "right"],
      textAlignments: ["left", "center", "right"],
      superOrgMetasets: ["sfx.asset.model", "sfx.asset.transform", "sfx.asset.assembly"],
    };
  },
  beforeMount() {
    this.element.formElementType = vFormControls["PART_LEGEND"];
    if (!this.element.titleAlignment) {
      this.$set(this.element, "titleAlignment", "left");
    }
    if (!this.element.textAlignment) {
      this.$set(this.element, "textAlignment", "left");
    }
  },
  methods: {
    updateMetaFieldSelection(selectedMetaFields) {
      console.log('selectedMetaFields', selectedMetaFields);
      this.$set(this.element, "metaFields", selectedMetaFields);
    },
    setTitleAlignment(val) {
      this.$set(this.element, "titleAlignment", val);
    },
    setTextAlignment(val) {
      this.$set(this.element, "textAlignment", val);
    },
  }
};
</script>

<style lang="scss">
.vform-alignment-button {
  background-color: var(--vform-editor-ui-secondary-color);
  border-radius: 1px;
  margin-left: 1px;
  width: 25px;
  height: 25px;
  position: relative;
  color: #fff;

  .icon {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  &.active {
    background-color: var(--vform-editor-accent-color);
  }
}

.vform-hint {
  border-radius: 3px;
  padding: 3px;
  font-size: 0.8rem;
  background-color: var(--vform-editor-ui-secondary-color);
  color: var(--vform-editor-ui-primary-color);
}
</style>